import { useMutation, UseMutationResult, useQuery, UseQueryResult } from 'react-query';
import type { ResponseFormat } from '../algebra/global';

import { Http } from '../prelude/http';
import type { IConversationMessage } from './../algebra/conversations/index';

export const fetchExistingMessages = async (task_sid: string): Promise<Array<IConversationMessage>> =>
  Http.Request<ResponseFormat<Array<IConversationMessage>>>('GET', `/hotlines/api/v1/conversations.get?task_sid=${task_sid}`).then((res) => res.data);

/**
 * Used to get existing Messages for Any OHL/TxHL
 * @param task_sid
 */
export const useGetMessages = (task_sid: string): UseQueryResult<Array<IConversationMessage>> => {
  return useQuery(['survivors_messages', task_sid], () => fetchExistingMessages(task_sid), {
    enabled: task_sid !== null && task_sid !== undefined,
  });
};

/**
 *!Used to submit feedback forms
  !4th Feb 2022
 */
interface IFormSubmissionModel {
  form_id: string;
  submission: Record<string, unknown>;
}
export const useSubmitVisitorFeedback = (): UseMutationResult<IFormSubmissionModel, unknown, IFormSubmissionModel, unknown> => {
  return useMutation(async (data) => Http.Request<ResponseFormat<IFormSubmissionModel>>('POST', `/resources/api/v1/visitor/form-submissions.create`, {}, data).then((res) => res.data));
};
